/* eslint-disable react/jsx-props-no-spreading */
import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';

import * as Components from '../cards/blocks';
import Sponsor from '../partials/Sponsor';
import ItemsBlock from './ItemsBlock';

import styles from '../../styles/blocks/cards-block.module.css';

interface CardsBlockProps {
    cards: Card[];
    sponsor?: Sponsor | null;
    className?: string | null;
}

function CardsBlock({ cards, sponsor = null, className, ...otherProps }: CardsBlockProps) {
    const [{ type: cardType = null }] = cards || [];
    const Component = getComponentFromName(Components, cardType, 'default');
    return Component !== null ? (
        <ItemsBlock
            {...otherProps}
            title={
                sponsor !== null ? (
                    <Sponsor
                        {...sponsor}
                        withImage
                        className={styles.sponsor}
                        imageClassName={styles.sponsorImage}
                    />
                ) : null
            }
            className={classNames([styles.container, className])}
            titleClassName={styles.title}
            items={cards}
            cardComponent={Component}
            withoutLoader
            presentation="grid"
            minColumns={2}
            cardWidth={200}
            withoutMaxWidth
        />
    ) : null;
}

export default CardsBlock;
